import axios from "axios";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";
import Modal from "../../../components/Modal/Modal";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";

const initialData = {
    fell_out_of_contract: "",
};

const FellOutContract = ({ showModal, onClose, onCallApi, id, from }) => {
    const [config] = useAuth();
    const [disable, setDisable] = useState(false);
    const [error, setError] = useState({});
    const [formData, setFormData] = useState(initialData);

    const isExecuted = from === "executedloi";

    // ✅ Dynamic UI Text
    const modalTitle = isExecuted
        ? "Convert To Fell Out Of Executed LOI"
        : "Convert To Fell Out Of Contract";

    const modalDesc = isExecuted
        ? "Add the Fell Out Of Executed LOI Information"
        : "Add the Fell Out Of Contract Information";

    const fieldLabel = isExecuted
        ? "Fell Out Of Executed LOI"
        : "Fell Out Of Contract";

    const handleChange = (value, name) => {
        setError({ ...error, [name]: "" });
        setFormData({ ...formData, [name]: value });
    };

    const handleClose = () => {
        setFormData(initialData);
        setError({});
        setDisable(false);
        onClose();
    };

    const handleUpdateStatus = (e) => {
        e.preventDefault();

        // ✅ Validation
        if (!formData.fell_out_of_contract) {
            setError({
                fell_out_of_contract: "This field is required",
            });
            return;
        }

        setDisable(true);

        // ✅ Format Date (MM/DD/YYYY)
        const formattedDate = new Date(formData.fell_out_of_contract)
            .toLocaleDateString("en-US");

        const dataToSend = {
            fell_out_of_contract: formattedDate,
        };

        // ✅ Dynamic Endpoint
        const endpoint = isExecuted
            ? `${BASE_URL}/fell-out-of-executed/${id}`
            : `${BASE_URL}/fell-out-of-contract/${id}`;

        axios
            .post(endpoint, dataToSend, config)
            .then((res) => {
                onCallApi();
                handleClose();

                if (res?.data?.message) {
                    NotificationManager.success(res?.data?.message);
                }
            })
            .catch((err) => {
                if (
                    err.response?.data?.message &&
                    err.response?.data?.message !== "Too Many Attempts."
                ) {
                    NotificationManager.error(
                        err.response?.data?.message
                    );
                }
            })
            .finally(() => {
                setDisable(false);
            });
    };

    useEffect(() => {
        if (showModal) {
            setFormData(initialData);
            setError({});
            setDisable(false);
        }
    }, [showModal]);

    return (
        <Modal
            title={modalTitle}
            desc={modalDesc}
            show={showModal}
            onClose={handleClose}
        >
            <form onSubmit={handleUpdateStatus}>
                <div className="mt-6">
                    <label className="dark-H head-4 mb-2">
                        {fieldLabel} <span className="red-D">*</span>
                    </label>

                    <DatePicker
                        className="body-N"
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        selected={formData.fell_out_of_contract}
                        onChange={(date) =>
                            handleChange(date, "fell_out_of_contract")
                        }
                    />

                    {error?.fell_out_of_contract && (
                        <span className="body-S red-D">
                            {error?.fell_out_of_contract}
                        </span>
                    )}
                </div>

                <div className="mt-7">
                    <button
                        type="submit"
                        disabled={disable}
                        className={`save-button light-L head-5 ${
                            disable ? "opacity-50 cursor-not-allowed" : "green-bg-H"
                        }`}
                    >
                        {disable ? "Saving..." : "Save"}
                    </button>

                    <button
                        type="button"
                        onClick={handleClose}
                        className="green-H ml-5"
                        disabled={disable}
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default FellOutContract;
